/* kw-pdp-sections.js - format C for the three PDP content sections.

   Restructures what the theme has already rendered. It does NOT touch the gallery, price,
   swatches, add-to-cart or the sticky bar, and it never writes to the product.

   Why client-side: sections/main-product.liquid is 190 KB, which the Shopify code editor
   cannot open, and the three blocks are the only thing being changed. This follows the
   pattern kw-sale-badge and kw-boost-oos already use - a CSS/JS pair loaded from
   snippets/boost-cookie-script.liquid, which is rendered site-wide.

   What Liquid does before this runs, and the trap in it: it rewrites <b> section labels to
   <h4> and strips the empty <ul></ul> and the stray FALSCH - but only for a CASE-SENSITIVE
   WHITELIST of two labels per locale. "Eigenschaften"/"Lieferumfang" and "Features"/"Scope of
   delivery" convert. "Properties", "Scope of Delivery" with a capital D, "Details",
   "TECHNICAL DATA" and "Produktinformationen" do not - and on those products FALSCH survives
   too, on 533 English pages. Measured: 3,728 EN (55.4%) and 231 DE products carry at least one
   label Liquid leaves as <b>. An earlier version of this file assumed the conversion was
   universal, parsed only <h4>, and silently deleted the delivery heading on all of them.
   walkSections() therefore treats <b>, <strong> and <h1-h6> alike, at any depth.

   What it does fix, because Liquid does not:
     - the KOMPATIBEL MIT: / COMPATIBLE WITH: keyword bullet (94.8% of products)
     - the trailing " in <colour>", which names variant #1 and is wrong for every other one
     - Product Details rows that are empty, whitespace-only or a raw [dsgNN] design code
     - "Hersteller: Apple" / "Manufacturer: Apple", which names the device brand as the maker
     - Material 1 + Material 2 as two rows, and H x B x L dimension order
*/
(function () {
  "use strict";

  var DE = document.documentElement.lang.toLowerCase().indexOf("de") === 0;

  var T = DE ? {
    delivery: "Lieferumfang",
    features: ["eigenschaften", "produkteigenschaften", "merkmale"],
    deliveryHeads: ["lieferumfang", "produktinformation", "produktinformationen"],
    compat: ["kompatibel mit:", "kompatibilitat:", "kompatibilitaet:"],
    compatBrand: "Kompatible Marke",
    manufacturer: ["hersteller"],
    material: "Material",
    materialKeys: ["material 1", "material 2"],
    dims: ["masse", "abmessungen"],
    dimsLabel: "Maße",
    dimsOrder: "(L x B x H)",
    specCaption: "Alle Produktdaten"
  } : {
    delivery: "Scope of delivery",
    /* The German labels are in the English set on purpose. 2,393 products have no English
       record, so the UK storefront serves them German body_html while lang=en selects this
       branch. Without them those pages keep the keyword bullet and build no delivery block. */
    features: ["features", "properties", "details", "eigenschaften", "produkteigenschaften"],
    deliveryHeads: ["scope of delivery", "product information", "delivery scope",
      "lieferumfang", "produktinformation", "produktinformationen"],
    compat: ["compatible with:", "compatibility:", "kompatibel mit:", "kompatibilitat:"],
    compatBrand: "Compatible brand",
    manufacturer: ["manufacturer"],
    material: "Material",
    materialKeys: ["material 1", "material 2"],
    dims: ["dimensions", "measurements"],
    dimsLabel: "Dimensions",
    dimsOrder: "(L × W × H)",
    specCaption: "All specifications"
  };

  /* Reviewed colourways that are not among a product's own option values. Same closed list as
     pdp-rebuild/parse_lib.py - exact match only, never a pattern, or it eats product names.
     "6x Ersatz In-Ear Kopfhoerer in 3 Groessen" must survive, and does. */
  var EXTRA = ["black", "red", "cream", "neon pink", "lime green", "bright yellow", "fir green",
    "stone dust", "metallic pink", "metallic grey", "metallic petrol", "metallic turquoise",
    "metallic lavender", "metallic blackberry", "metallic rose gold", "metallic rosegold",
    "metallic caribbean blue", "schwarz", "tannengrün", "strahlend gelb",
    "carbon design", "scrunchie design", "scrunchie hair tie design"];

  function norm(s) {
    return (s || "").replace(/\s+/g, " ").trim().toLowerCase();
  }
  /* Label matching only. Lowercasing alone leaves the eszett and the umlauts in place,
     so a plain compare silently missed the dimensions row on the German storefront. */
  function fold(s) {
    return norm(s).replace(/ß/g, "ss").replace(/ä/g, "a")
      .replace(/ö/g, "o").replace(/ü/g, "u");
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* Every option value on this product, so a colour can be stripped only when it is one the
     product actually sells. Read from the variant JSON the theme already prints. */
  function optionValues() {
    var out = [];
    document.querySelectorAll('script[type="application/json"]').forEach(function (s) {
      var txt = s.textContent || "";
      if (txt.indexOf('"option1"') === -1) return;
      try {
        var data = JSON.parse(txt);
        var arr = Array.isArray(data) ? data : (data.variants || []);
        arr.forEach(function (v) {
          ["option1", "option2", "option3"].forEach(function (k) {
            if (v && v[k]) out.push(String(v[k]));
          });
        });
      } catch (e) { /* not the variant blob */ }
    });
    document.querySelectorAll("[data-variant-option-value], .product-form__input input[value]")
      .forEach(function (i) {
        var v = i.getAttribute("data-variant-option-value") || i.value;
        if (v) out.push(v);
      });
    return out;
  }

  /* Same word set, any order. The English delivery clause and the English option value are
     translated independently and come out reversed: the line says "in petrol matte" while the
     swatch says "Matte Petrol". Comparing sorted tokens matches those without loosening the
     rule - it is still an exact match against a value this product actually sells. */
  function tokens(s) {
    return norm(s).replace(/[^a-z0-9À-ɏ ]/g, " ").split(/\s+/)
      .filter(Boolean).sort().join(" ");
  }

  function stripColour(text, colours) {
    var m = /\s+in\s+(.+)$/i.exec(text);
    if (!m) return text;
    var tail = norm(m[1]), tailTok = tokens(m[1]);
    for (var i = 0; i < colours.length; i++) {
      var c = norm(colours[i]);
      if (c && (tail === c || tailTok === tokens(colours[i]))) return text.slice(0, m.index);
    }
    if (EXTRA.indexOf(tail) !== -1) return text.slice(0, m.index);
    return text;
  }

  /* A compatibility bullet that carries a NEGATIVE fitment warning is not keyword spam - it is
     the only place the page says what the product does NOT fit. Measured: dropping it would
     have removed that warning from 142 DE and 159 EN products where it appears nowhere else,
     e.g. "NICHT KOMPATIBEL mit Samsung Galaxy S22+ oder S22 Ultra!" and
     "NUR Modellnummern: A2133 / A2124". At this AOV a wrong-model return costs more than the
     sale, so these are kept and relabelled rather than deleted. */
  var NEGFIT = /nicht kompatibel|not compatible|passt nicht|does not fit|nur für modellnummer|nur modellnummern|only model number|\bA\d{4}\b/i;

  function isNegativeFitment(text) {
    return NEGFIT.test(text);
  }

  function isCompat(text) {
    /* fold(), not norm(). norm() only lowercases, so KOMPATIBILITAT-with-umlaut never matched
       the folded prefix and 1,003 German products kept the keyword bullet. The Python pipeline
       in pdp-rebuild/parse_lib.py strips accents inside norm() and was never affected. */
    if (isNegativeFitment(text)) return false;
    var n = fold(text);
    for (var i = 0; i < T.compat.length; i++) if (n.indexOf(T.compat[i]) === 0) return true;
    return false;
  }

  /* 99.1% of bullets are "LEAD-IN: sentence". The rest render as a plain sentence - no
     eyebrow is invented for them. */
  function featureRow(html, forcedLabel) {
    var li = el("li");
    var text = html;
    var label = forcedLabel || null;
    if (!label) {
      var m = /^([^:<]{2,48}):\s+/.exec(html.replace(/<[^>]+>/g, ""));
      if (m) {
        label = m[1];
        text = html.replace(/^([^:<]{2,48}):\s+/, "");
      }
    }
    if (label) {
      /* Set as HTML, not text: the label is lifted out of the stored markup and still
         carries entities, so textContent would print a literal &amp; to customers.
         No case transform - the stylesheet uppercases it, and title-casing here
         lowercased German nouns ("SCHNICKSCHNACK" -> "schnickschnack"). */
      var cls = "kwc__eyebrow";
      /* Caveats must not look like features. 1,784 DE lead-ins are ACHTUNG / Hinweis /
         Wichtig, and a negative fitment line is the most important warning on the page. */
      if (isNegativeFitment(html) || /^(achtung|hinweis|wichtig|bitte beachte|caution|note|please note|important)/i.test(label)) {
        cls += " kwc__eyebrow--warn";
      }
      li.appendChild(el("span", cls, label));
    }
    li.appendChild(el("span", "kwc__t", text));
    return li;
  }

  /* Document-order walk. Liquid only converts a case-sensitive whitelist of <b> labels to <h4>,
     the <b> is not always a top-level child, and the delivery <ul> is nested inside the features
     <ul> - the same invalid nesting pdp-rebuild/parse_lib.py tokenises flat. So take anything
     label-shaped as a section start and let every <li> join the current section, whatever the
     depth. Verified on kwm000022zh000p, klb000026hx000p and kwm000007wq000p. */
  function walkSections(root) {
    var intro = [], sections = [], cur = null, seen = false;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT), n;
    while ((n = w.nextNode())) {
      var tag = n.tagName;
      var isHead = /^H[1-6]$/.test(tag) || tag === "B" || tag === "STRONG";
      /* a <b> inside an <li> is inline emphasis in a sentence, not a section label */
      if (isHead && n.closest("li")) isHead = false;
      if (isHead) {
        var label = n.textContent.trim();
        if (!label || label.length > 60) continue;
        cur = { label: label, items: [] };
        sections.push(cur);
        seen = true;
        continue;
      }
      if (tag === "LI") {
        if (n.querySelector("li")) continue;   /* outer half of a nested pair */
        var html = n.innerHTML.trim();
        if (!html) continue;
        if (!cur) { cur = { label: "", items: [] }; sections.push(cur); }
        cur.items.push(html);
        continue;
      }
      if (tag === "P" && !seen) {
        if (n.querySelector("b,strong,h1,h2,h3,h4,h5,h6")) continue;  /* heading wrapper */
        var t = n.textContent.trim();
        if (t) intro.push(n.innerHTML.trim());
      }
      if (tag === "BR" && !seen && intro.length) intro.push("<br>");
    }
    /* join with a break, not a space: a multi-paragraph intro keeps its shape */
    return { intro: intro.join("<br>"), sections: sections };
  }

  function buildDescription(root) {
    if (root.dataset.kwc === "1") return;
    var colours = optionValues();

    var parsed = walkSections(root);
    /* No headings and no list items means this is not the generated template at all - it is a
       hand-written prose description. Measured on kwm0000080b000s (8 paragraphs, 111 words) and
       kwm0000086q000s (6 paragraphs, 165 words), where every word is the only copy the product
       has. Rendering those as a demoted grey footnote would destroy them, so leave the theme's
       markup exactly as it is. */
    if (!parsed.sections.length) return;

    var lede = null, feats = [], delivery = [], order = [];
    lede = parsed.intro || null;

    parsed.sections.forEach(function (sec) {
      var head = sec.label;
      var n = fold(head.replace(/:\s*$/, ""));
      var kind = T.deliveryHeads.indexOf(n) !== -1 ? "delivery"
        : T.features.indexOf(n) !== -1 ? "features" : "other";
      var items = sec.items;
      if (kind === "delivery") {
        delivery = delivery.concat(items.map(function (t) { return stripColour(t, colours); }));
        return;
      }
      items = items.filter(function (t) { return !isCompat(t); });
      if (!items.length) return;
      /* A heading that ends in a colon and holds one bullet is not a section - it is a
         feature the source template broke apart. Fold it back in. */
      if (items.length === 1 && head && /:\s*$/.test(head)) {
        feats.push({ label: head.replace(/:\s*$/, ""), html: items[0] });
      } else {
        order.push({ head: kind === "features" ? null : head, items: items });
      }
    });

    var frag = document.createDocumentFragment();

    if (feats.length) {
      var ulF = el("ul", "kwc__feat");
      feats.forEach(function (f) { ulF.appendChild(featureRow(f.html, f.label)); });
      frag.appendChild(ulF);
    }
    order.forEach(function (sec) {
      if (sec.head) frag.appendChild(el("p", "kwc__subhead", sec.head));
      var ul = el("ul", "kwc__feat");
      sec.items.forEach(function (t) { ul.appendChild(featureRow(t)); });
      frag.appendChild(ul);
    });

    if (delivery.length) {
      var box = el("div", "kwc__box");
      box.appendChild(el("h3", null, T.delivery));
      var ulD = el("ul", "kwc__boxlist");
      delivery.forEach(function (t) {
        var m = /^\s*(\d+)\s*[x×]\s*/i.exec(t);
        var q = m ? m[1] : "1";
        var rest = m ? t.slice(m[0].length) : t;
        var li = el("li");
        li.appendChild(el("span", "kwc__q", q + "×"));
        li.appendChild(el("span", null, rest));
        ulD.appendChild(li);
      });
      box.appendChild(ulD);
      frag.appendChild(box);
    }

    /* The brand boilerplate is identical on 5,638 of 6,730 products, so it goes last. */
    if (lede && lede.replace(/<[^>]+>/g, "").trim().split(/\s+/).length > 3) {
      frag.appendChild(el("p", "kwc__lede--demoted", lede));
    }

    root.classList.add("kwc");
    root.innerHTML = "";
    root.appendChild(frag);
    root.dataset.kwc = "1";
  }

  function fixLabel(label, value) {
    var n = fold(label.replace(/:\s*$/, ""));
    if (T.manufacturer.indexOf(n) !== -1) return [T.compatBrand, value];
    if (T.dims.indexOf(n) !== -1) {
      /* "1,3 cm x 7,3 cm x 15 cm(H x B x L)" -> "15 x 7,3 x 1,3 cm (L x B x H)" */
      /* Only reverse when the value itself declares H x B/W x L. Reversing any three numbers
         and asserting the new order would put transposed measurements on any page whose source
         was written differently - and nothing in the review CSVs covers spec rows, so this rule
         has never been checked at scale. Unrecognised formats pass through untouched. */
      var declared = /\(\s*H\s*[x×]\s*[BW]\s*[x×]\s*L\s*\)/i.test(value);
      var parts = value.match(/([\d.,]+)\s*cm/g);
      if (declared && parts && parts.length === 3) {
        var nums = parts.map(function (p) { return p.replace(/\s*cm/, ""); }).reverse();
        return [T.dimsLabel, nums.join(" × ") + " cm " + T.dimsOrder];
      }
      return [T.dimsLabel, value.replace(/cm\(/, "cm (")];
    }
    return [label.replace(/:\s*$/, ""), value];
  }

  function buildSpec(ped) {
    /* Move the theme's own markup into a hidden wrapper rather than deleting it. The theme
       updates the SKU on a swatch click by writing into [data-variant-sku]; deleting that
       element froze the table on variant #1. Hidden, it keeps receiving those updates and
       this reads back from it. */
    var src = ped.querySelector(":scope > .kwc__src");
    if (!src) {
      src = el("div", "kwc__src");
      while (ped.firstChild) src.appendChild(ped.firstChild);
      ped.appendChild(src);
    }
    var labels = src.querySelectorAll(".product-extra-details__label");
    var values = src.querySelectorAll(".product-extra-details__value");
    if (!labels.length || labels.length !== values.length) return;

    var rows = [], materials = [];
    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i].textContent.trim();
      var val = values[i].textContent.trim();
      var nLab = fold(lab.replace(/:\s*$/, ""));
      /* Empty values never reach the DOM - Product-Extra-Details.liquid already gates every
         field on `!= blank` - so there is nothing to hide here. A raw [dsgNN] code is kept: on
         1,889 products there is no Farbe option at all and the code is the only thing naming
         the selected variant. Showing a code is bad; showing nothing is worse. */
      if (!val) { continue; }
      if (T.materialKeys.indexOf(nLab) !== -1) { materials.push(val); continue; }
      rows.push(fixLabel(lab, val));
    }
    if (materials.length) {
      /* "SilikonBeschichtung" is one German word with a stray capital, not two words:
         lowercase the second element rather than inserting a space. English values are left
         alone - "Aramid Fiber" is correctly two words. */
      var mat = materials.map(function (m) {
        return DE ? m.replace(/([a-zäöüß])([A-ZÄÖÜ])/g,
          function (_, a, b) { return a + b.toLowerCase(); }) : m;
      });
      /* "und" not "mit": the two values are both materials, not a thing and its coating -
         except when the second IS a coating, where "mit" is the accurate relation. */
      var join = DE
        ? (/beschichtung|schicht$/i.test(mat[mat.length - 1] || "") ? " mit " : " und ")
        : " with ";
      rows.splice(Math.min(3, rows.length), 0, [T.material, mat.join(join)]);
    }
    if (!rows.length) return;

    /* Re-render only when a value actually changed, so this is safe to call on every mutation. */
    var sig = rows.map(function (r) { return r[0] + "=" + r[1]; }).join("|");
    if (ped.dataset.kwcSig === sig) return;
    ped.dataset.kwcSig = sig;

    var wrap = el("div", "kwc__tablewrap");
    var table = el("table", "kwc__spec");
    var cap = el("caption", "kwc__subhead", T.specCaption);
    cap.style.textAlign = "left";
    table.appendChild(cap);
    var tb = el("tbody");
    rows.forEach(function (r) {
      var tr = el("tr");
      var th = el("th", null, r[0]);
      th.setAttribute("scope", "row");
      var td = el("td", /\d/.test(r[1]) ? "kwc--num" : null, r[1]);
      tr.appendChild(th); tr.appendChild(td); tb.appendChild(tr);
    });
    table.appendChild(tb);
    wrap.appendChild(table);

    ped.classList.add("kwc");
    var prevT = ped.querySelector(":scope > .kwc__tablewrap");
    if (prevT) prevT.remove();
    var prevD = ped.querySelector(":scope > .kwc__dropped");
    if (prevD) prevD.remove();
    ped.appendChild(wrap);
  }

  function run() {
    var desc = document.querySelector('[id^="ProductAccordion-collapsible_description"]');
    if (desc) { try { buildDescription(desc); } catch (e) { /* leave the theme's markup */ } }
    document.querySelectorAll(".product-extra-details").forEach(function (p) {
      try { buildSpec(p); } catch (e) { /* leave the theme's markup */ }
    });
  }

  /* Watch only what actually changes, never the whole document.

     An observer on document.documentElement with subtree:true saw 4,280 mutations on one PDP
     from the other apps on the page. A trailing debounce behind that never settles, so the spec
     table froze on variant #1, and the callback ran constantly on every page for nothing.

     Scoped like this the same swatch click produces one mutation and one rebuild. */
  function watch() {
    var ped = document.querySelector(".product-extra-details");
    if (ped && !ped.dataset.kwcWatched) {
      var src = ped.querySelector(":scope > .kwc__src");
      if (src) {
        ped.dataset.kwcWatched = "1";
        new MutationObserver(function () { buildSpec(ped); })
          .observe(src, { childList: true, subtree: true, characterData: true });
      }
    }
    /* body_html is product-level in Shopify - the same text for every variant - so the
       description never needs re-reading on a swatch click. It only needs rebuilding if the
       theme replaces the node, which a childList watch on the parent catches. */
    var desc = document.querySelector('[id^="ProductAccordion-collapsible_description"]');
    var host = desc && desc.parentElement;
    if (host && !host.dataset.kwcWatched) {
      host.dataset.kwcWatched = "1";
      new MutationObserver(function () { run(); })
        .observe(host, { childList: true });
    }
  }

  function boot() { run(); watch(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
